import { render, staticRenderFns } from "./sales-order.vue?vue&type=template&id=5d6da56d&scoped=true&"
import script from "./sales-order.vue?vue&type=script&lang=js&"
export * from "./sales-order.vue?vue&type=script&lang=js&"
import style0 from "./sales-order.vue?vue&type=style&index=0&id=5d6da56d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6da56d",
  null
  
)

export default component.exports